<script lang="ts">
  import { Content, Tabs, Tab } from 'carbon-components-svelte'
  import { tick } from 'svelte'

  import TabContent from './components/TabContent.svelte'
  import Header from './components/Header.svelte'
  import Theme from './components/Theme.svelte'
  import Login from './components/Login.svelte'
  import Lobby from './components/Lobby.svelte'
  import FloatingLobbyChat from './components/FloatingLobbyChat.svelte'
  import Game from './components/Game.svelte'

  import type { LoginEvent } from './events'

  import ConnectionStore from './stores/connection'
  import GamesStore from './stores/games'

  let theme: 'g10' | 'g100' = 'g10'

  const playingGames = GamesStore.runningGames


  function doLogin({ detail }: CustomEvent<LoginEvent>) {
    ConnectionStore.connect(detail)
  }
  const {
    isLoggingIn,
    loggedIn,
    username,
    hostname: initialHostname,
    port: initialPort,
  } = ConnectionStore

  function toggleTheme() {
    theme = theme === 'g10' ? 'g100' : 'g10'
  }

  let numberOfPlayingGames = 0
  let selectedTabIndex = 0

  // always focus new tab
  $: if ($playingGames.length != numberOfPlayingGames) {
    numberOfPlayingGames = $playingGames.length
    selectedTabIndex = $playingGames.length
  }
</script>

<Theme persist bind:theme>
  <Header on:toggleTheme={toggleTheme} />
  {#if !$loggedIn}
    <Content style="background: none; padding: 1rem">
      <Login
        on:doLogin={doLogin}
        loggingIn={$isLoggingIn}
        initialUsername={$username}
        initialHostname={$initialHostname}
        initialPort={$initialPort}
      />
    </Content>
  {:else}
    <Content
      style="background: none; padding: 0rem; width: 100vw; display: flex; flex-direction: column;"
    >
      <Tabs aria-label="Tab navigation" bind:selected={selectedTabIndex}>
        <Tab label="Lobby" />
        {#each $playingGames as { title }}
          <Tab label={title} />
        {/each}
        <div
          slot="content"
          class="tabbed-content"
          style="padding: 0rem; display: flex; flex-direction: column; flex-grow: 1;"
        >
          <!-- <Grid as fullWidth let:props> -->
          <TabContent style="margin: 1rem;">
            <!-- {...props} -->
            <Lobby />
          </TabContent>
          {#each $playingGames as { gameId }}
            <TabContent
              customClasses="tab-content-flex-row"
              style="margin-left: 0; margin-right: 0; padding:0; flex-grow: 1"
              ><!--  {...props} -->
              <Game {gameId} />
            </TabContent>
          {/each}
          <!-- </Grid> -->
        </div>
      </Tabs>
    </Content>
    <FloatingLobbyChat />
  {/if}
</Theme>

<style>
  :global(.tab-content-flex-col:not([hidden])) {
    display: flex;
    flex-direction: column;
  }

  :global(.tab-content-flex-row:not([hidden])) {
    display: flex;
    flex-direction: row;
  }

  :global(*::selection) {
    background-color: #ffffff28;
  }
</style>
